import { CONSTANTS } from "utils";
import "./Footer.scss";
import lenditLogo from "assets/Lendit-logo.png";
import { SocialMedia } from "../SocialMedia/SocialMedia";

export const 
Footer = () => {

	return (
		<div className="footer-container">
			<div className="column" id="logo-media">
				<img src={lenditLogo} alt="logo" className="logo" />
				<SocialMedia />
			</div>
			<div className="column">
				<span>Visitanos</span>
				<ul>
					<li>
						<a href={CONSTANTS.PAGES.HOME}>Inicio</a>
					</li>
					<li>
						<a href={CONSTANTS.PAGES.ABOUT_US}>Sobre nosotros</a>
					</li>
					{/* <li>
						<a href={CONSTANTS.PAGES.BLOG}>Blog</a>
					</li> */}
					<li>
						<a href={CONSTANTS.PAGES.CONTACT}>Contacto</a>
					</li>
					{/* <li>
						<a href={CONSTANTS.PAGES.PRODUCTS}>Productos</a>
					</li> */}
				</ul>
			</div>
			<div className="column">
				<span>Nuestras políticas</span>
				<ul>
					<li>
						<a href={CONSTANTS.PAGES.LEGAL_ADVISE}>Aviso legal</a>
					</li>
					<li>
						<a href={CONSTANTS.PAGES.PRIVACY_POLICY}>Política de privacidad</a>
					</li>
				</ul>
			</div>
			<span className="reserved-rights">© 2024 Lendit. Todos los derechos reservados.</span>
		</div>
	);
};